<template>
  <div>
    <el-dialog :visible.sync="peopleFaceDialog"
               width="75%"
               class="peopleFaceListDialog"
               :before-close="peopleFaceDialogHandleClose">
      <div slot="title"
           class="header-title"
           :style="{'padding':'15px 20px','box-sizing':'border-box','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
        <div>{{'人物列表 ：   ' + nowPeopleInfo.peopleName}}</div>
      </div>
      <!-- <div style="text-align: center;margin: 20px 0;font-size: 20px;">{{nowPeopleInfo.peopleName}}</div> -->
      <div class="peopleFaceList">
        <div v-for="(item,index) in peopleFaceList"
             class="peopleFace"
             :key="index"
             @click="seeBigImg(item.srcBig,index)">

          <img :src="item.src"
               class="img"
               alt="">
        </div>
      </div>
      <div class="block"
           v-if="peopleFaceList.length">
        <el-pagination @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page="currentPage"
                       :page-sizes="[10, 20,30, 40]"
                       :page-size="pageSize"
                       layout="total, sizes, prev, pager, next"
                       :total="paginationTotal">
        </el-pagination>
      </div>
      <div v-if="peopleFaceList.length==0"
           class="nonr">
        <img src="@/assets/piclist/nonr.png"
             alt="">
      </div>
      <!-- <span slot="footer"
            class="dialog-footer">
        <el-button @click="peopleFaceDialogHandleClose">取 消</el-button>
        <el-button type="primary"
                   @click="peopleFaceDialogHandleClose">确 定</el-button>
      </span> -->
    </el-dialog>
    <div class="seeBigImg"
         v-if="seeBigImgFlag">
      <div class="leftBtn"
           @click="leftbtn"><i class="el-icon-arrow-left"></i></div>
      <div class="rightBtn"
           @click="rightbtn"><i class="el-icon-arrow-right"></i></div>
      <div class="imgbox"
           @click="seeBigImgFlag = false"
           :style="'background: url('+nowBigImgSrc+') no-repeat;'"></div>
      <!-- <div class="imgbox"
           @click="peopleFaceDialog = false"
           style="background: url(http://cdp-local-web.test.routeryuncs.com/uploads/picture/2020-07-28/e32891ccdf318b00cc24f850e129160b.jpg@w240h160.jpg) no-repeat;background-size: contain;background-position: center;"></div> -->

    </div>
  </div>
</template>
<script>
import { searchPicture } from "@/api/search";
import { picPrefix } from "@/constants/piccommon";
export default {
  data () {
    return {
      picPrefix,
      peopleFaceDialog: false,//人脸列表dialog
      peopleFaceList: [],//人脸集合
      nowPeopleInfo: '',//当前人脸信息
      seeBigImgFlag: false,
      nowBigImgSrc: '',
      screenHeight: 0,
      screenWidth: 0,
      nowImgIndex: -1,//当前点击图片index

      currentPage: 1,
      paginationTotal: 0,
      pageSize: 20,
    }
  },
  methods: {
    handleSizeChange (val) {
      this.pageSize = val
      this.searchPictureAsync(this.nowPeopleInfo.peopleId)
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.searchPictureAsync(this.nowPeopleInfo.peopleId)
    },
    leftbtn () {
      if (this.nowImgIndex == 0) {
        return;
      }
      this.nowImgIndex--
      this.nowBigImgSrc = this.peopleFaceList[this.nowImgIndex].srcBig
    },
    rightbtn () {
      if (this.nowImgIndex == this.peopleFaceList.length - 1) {
        return;
      }
      this.nowImgIndex++
      this.nowBigImgSrc = this.peopleFaceList[this.nowImgIndex].srcBig
    },
    seeBigImg (url, index) { //看大图
      this.nowImgIndex = index
      this.nowBigImgSrc = url
      this.seeBigImgFlag = true
      this.peopleFaceDialog = true

    },
    peopleFaceDialogHandleClose () {
      this.peopleFaceDialog = false
      this.$emit('clickFaceDialogHandleClose')
    },
    getInfo (nowPeopleInfo) {
      console.log(nowPeopleInfo);
      this.nowPeopleInfo = nowPeopleInfo
      this.searchPictureAsync(nowPeopleInfo.peopleId)
      this.peopleFaceDialog = true

    },
    async searchPictureAsync (peopleId) {
      this.peopleFaceList = []
      let val = {
        pageSize: this.pageSize,
        page: this.currentPage - 1,
        peopleId: peopleId
      }
      let { status, data, pagination } = await searchPicture(val);
      if (status) {
        for (let i = 0; i < data.length; i++) {
          // console.log(data[i].fileInfo.picThumbH160);
          data[i].src = this.picPrefix + data[i].fileInfo.picThumbH160
          data[i].srcBig = this.picPrefix + data[i].fileInfo.picThumbW1080
        }
        this.peopleFaceList = data
        this.paginationTotal = pagination.total
      }

    }
  },
  created () {
    this.screenHeight = document.documentElement.clientWidth;
    this.screenWidth = document.documentElement.clientHeight;
  }
}
</script>
<style lang="scss" scoped>
@import "@/constants/elHeader.scss";
@import "./seePeopleFace.scss";
.peopleFaceListDialog ::v-deep .el-dialog__body {
  height: 600px;
  overflow: auto;
  z-index: 9999;
  // padding-bottom: 20px;
}
// ::-webkit-scrollbar {
//   overflow-x: hidden;
// }
</style>